import { render, staticRenderFns } from "./FieldVideos.vue?vue&type=template&id=6d5dbc5f&"
import script from "./FieldVideos.vue?vue&type=script&lang=ts&"
export * from "./FieldVideos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports